import sortBy from "lodash/sortBy";
import React from "react";
import { getArrayIndex } from "../../../utils/lodash";
import MultiSelectDD from "../multiSelectDD";
import TextFieldWithToolTip from "../TextFieldWithToolTip/TextFieldWithToolTip";
import VirtualizedAutocomplete from "../VirtualizedAutocomplete/VirtualizedAutocomplete";
import SliderDatePicker from "../../common/SliderDatePicker/SliderDatePicker";
import {
  getDependentSourceData,
  isString,
  removeDuplicates,
  reportRadioRangeQTRSlider,
  reportRadioRangeSlider,
  reportRadioRangeWeeklySlider,
  reportRadioSlider
} from "../../../utils/helper";
import { standardDateFormat } from "../../../constants/appConstants";
import moment from "moment";

export class ReportPageFilter extends React.Component {
  constructor(props) {
    super(props);
    const {
      filterConfig,
      clearFilterData,
      reload,
      colFilteredObj,
      initialConfigData,
      reportSectionId
    } = this.props;
    this.state = {
      filterConfig: filterConfig,
      selectedIds: {},
      inputValues: null,
      clearFilterData: clearFilterData,
      reload: reload,
      dependentKey: null,
      allCleared: false,
      colFilteredObj: colFilteredObj || [],
      initialConfigData: initialConfigData || [],
      reportSectionId:reportSectionId
    };
  }

  static getDerivedStateFromProps(newProps, state) {
    if (
      newProps.colFilteredObj !== state.colFilteredObj ||
      newProps.clearFilterData !== state.clearFilterData ||
      newProps.reload !== state.reload ||
      newProps.filterConfig !== state.filterConfig
    ) {
      return {
        colFilteredObj: newProps.colFilteredObj,
        clearFilterData: newProps.clearFilterData,
        filterConfig: newProps.filterConfig,
        reload: newProps.reload
      };
    } else {
      return null;
    }
  }

  /**
   * set values on onchange event.
   * @param {*} value - selected value
   */
  onChangeVal = value => {
    const { inputValues } = this.state;
    this.setState({
      ...inputValues,
      [value.id]: value.value
    });
  };

  /**
   * call on multiselect dropdown to set multiselect value and also filters option list of dependant filter
   * @param {*} ids -> selected Ids
   * @param {*} optionsList -> selected dropdown option list
   * @param {*} key -> key name
   * @param {*} data type -> data type
   * @param {*} id
   * @param {*} dependentKeyName -> dependent filter key name
   * @param {*} bit
   */
  onMultiSelectDD = (
    ids,
    optionsList,
    key,
    dataKey,
    id,
    dependentKeyName,
    bit = 0
  ) => {
    let { colFilteredObj } = this.state;
    const { selectedIds, filterConfig } = this.state;
    const { selectedFilter } = this.props;
    let allIds = optionsList.map(function(item) {
      return item.id;
    });
    const mIds = selectedIds[key] || [];
    if (ids.indexOf("All") !== -1) {
      const filteredIds = ids.filter(f => f != "All");

      if (
        filteredIds.length == allIds.length ||
        (ids.length > 0 && ids[0] == "All") ||
        (mIds.indexOf("All") == -1 && ids.indexOf("All") !== -1)
      ) {
        if (optionsList.length == 1 && ids[0] == "All") {
          allIds = [];

          colFilteredObj = this.onChangeFilter(
            key,
            allIds || [],
            dataKey,
            id,
            colFilteredObj
          );
          this.setState({
            ...selectedIds,
            [key]: [],
            colFilteredObj
          }, () => {
            if (optionsList && optionsList[0].dependentFilter != null) {
              this.getDependentSource(optionsList, key, ids, colFilteredObj);
            } else {
              selectedFilter(colFilteredObj,filterConfig);
            }
          });
        } else {
          allIds.push("All");
          colFilteredObj = this.onChangeFilter(
            key,
            allIds || [],
            dataKey,
            id,
            colFilteredObj
          );
          this.setState({
            ...selectedIds,
            [key]: allIds,
            colFilteredObj
          }, () => {
            if (optionsList && optionsList[0].dependentFilter != null) {
              this.getDependentSource(optionsList, key, ids, colFilteredObj);
            } else {
              selectedFilter(colFilteredObj,filterConfig);
            }
          });
        }
      } else {
        const idsWithoutAll = ids.filter(f => f != "All");
        colFilteredObj = this.onChangeFilter(
          key,
          idsWithoutAll || [],
          dataKey,
          id,
          colFilteredObj
        );
        this.setState({
          ...selectedIds,
          [key]: idsWithoutAll,
          colFilteredObj
        }, () => {
          if (optionsList && optionsList[0].dependentFilter != null) {
            this.getDependentSource(optionsList, key, ids, colFilteredObj);
          } else {
            selectedFilter(colFilteredObj,filterConfig);
          }
        });
      }
    } else {
      if (mIds.indexOf("All") !== -1 && bit == 0) {
        colFilteredObj = this.onChangeFilter(
          key,
          [],
          dataKey,
          id,
          colFilteredObj
        );
        this.setState({
          ...selectedIds,
          [key]: [],
          colFilteredObj
        }, () => {
          if (optionsList && optionsList[0].dependentFilter != null) {
            this.getDependentSource(optionsList, key, ids, colFilteredObj);
          } else {
            selectedFilter(colFilteredObj,filterConfig);
          }
        });
      } else {
        ids = isString(ids) || (ids.length == 0 && bit == 1) ? allIds : ids;
        const idsWithoutAll = ids.filter(f => f != "All");
        if (idsWithoutAll.length == allIds.length) {
          allIds.push("All");
          colFilteredObj = this.onChangeFilter(
            key,
            allIds,
            dataKey,
            id,
            colFilteredObj
          );
          this.setState({
            ...selectedIds,
            [key]: allIds,
            colFilteredObj
          }, () => {
            if (optionsList && optionsList[0].dependentFilter != null) {
              this.getDependentSource(optionsList, key, ids, colFilteredObj);
            } else {
              selectedFilter(colFilteredObj,filterConfig);
            }
          });
        } else {
          colFilteredObj = this.onChangeFilter(
            key,
            ids,
            dataKey,
            id,
            colFilteredObj
          );
          this.setState({
            ...selectedIds,
            [key]: ids,
            colFilteredObj
          }, () => {
            if (optionsList && optionsList[0].dependentFilter != null) {
              this.getDependentSource(optionsList, key, ids, colFilteredObj);
            } else {
              selectedFilter(colFilteredObj,filterConfig);
            }
          });
        }
      }
    }
   
  };

  /**
   * filter the dropdown option according to key name
   * @param {*} optionsList -> list of options
   * @param {*} FilterKeyName -> key name
   * @param {*} value -> value of control
   */
  getDependentSource = (optionsList, key, value, colFilteredObj) => {
    const {
      allCleared,
    } = this.state;
    // eslint-disable-next-line react/no-access-state-in-setstate
    let data = {};
    
     data=getDependentSourceData(optionsList,key,value,this.state, colFilteredObj);

    this.setState(
      {
        filterConfig: data.configData,
        colFilteredObj: data.colFilteredObj,
        allCleared: !allCleared,
       dependentKey: optionsList[0].dependentFilter
      },
      () => {
        const { selectedFilter } = this.props;
        const colFiltered = data.colFilteredObj?.filter(e => {
          if (e.keyName !== optionsList[0].dependentFilter) return e;
        });
        selectedFilter(colFiltered,data.configData);
        this.setState({
          colFilteredObj: colFiltered
        });
        this.forceUpdate();
      }
    );
  };

  /**
   * call on slider
   * @param {*} start -> start date
   * @param {*} end -> end date
   * @param {*} typeOfDate -> type of slider
   * @param {*} QtrSelected -> quater selection
   * @param {*} key -> key name
   * @param {*} type -> data type
   */

  handleNullableSliderDate = (
    start,
    end,
    typeOfDate,
    QtrSelected,
    key,
    type
  ) => {
    let { colFilteredObj } = this.state;
    const { filterConfig } = this.state;
    const { selectedFilter } = this.props;
    if (typeOfDate == "NONE") {
      colFilteredObj = this.onChangeFilter(
        key,
        "NONE",
        type,
        "",
        colFilteredObj
      );
      this.setState({
        colFilteredObj
      }, () => {
        selectedFilter(colFilteredObj,filterConfig,false);
      });
    } else {
      const date = start + "-" + end;
      colFilteredObj = this.onChangeFilter(key, date, type, "", colFilteredObj);
      this.setState({
        colFilteredObj
      }, () => {
        selectedFilter(colFilteredObj,filterConfig,false);
      });
    }
  };

  /**
   * call method on every onchange of control
   * @param {*} filterKey -> key name
   * @param {*} value -> value of selected control
   * @param {*} type -> data type
   * @param {*} id ->
   * @param {*} colFilteredObj -> selected filter object data
   */
  onChangeFilter = (filterKey, value, type, id, colFilteredObj) => {
    const index = getArrayIndex(colFilteredObj, { keyName: filterKey });
    if (index !== -1) {
      colFilteredObj[index] = {
        keyName: filterKey,
        value,
        filterType: type || "string",
        idValue: id
      };
    } else {
      colFilteredObj = [
        ...colFilteredObj,
        {
          keyName: filterKey,
          value,
          filterType: type || "string",
          idValue: id
        }
      ];
    }
    return colFilteredObj;
  };

  /**
   * render component  according to values
   * @param {*} obj
   * @returns
   */
  decideFilterComp = (obj, index) => {
    const {
      selectedIds,
      clearFilterData,
      reload,
      dependentKey,
      allCleared,
      colFilteredObj,
      reportSectionId
    } = this.state;
    switch (obj.FilterDataType || "Text") {
      case "Text":
        return (
          <TextFieldWithToolTip
            key={obj.FilterKeyName + index}
            isForFilter
            id={obj.FilterKeyName}
            txtName={obj.FilterKeyName}
            disabled={false}
            value={
              colFilteredObj.find(x => x.keyName === obj.FilterKeyName)
                ?.value || ""
            }
            keyValue={""}
            onChange={e => this.onChangeVal(e.target)}
            isRequired={false}
            labelHeading={obj.FilterName}
            toolTip={""}
          />
        );
      case "MultiSelect":
        return (
          <>
            {obj.optionsList && obj.optionsList.length >= 0 && (
              <MultiSelectDD
                value={obj.optionsList.filter(
                  option =>
                    (
                      colFilteredObj.find(x => x.keyName === obj.FilterKeyName)
                        ?.value || []
                    ).find(selValue => selValue === option.id) !== undefined
                )}
                key={obj.FilterKeyName}
                header={obj.FilterName}
                className={"inline-filter"}
                optionsList={
                  obj.ShowLastValueInList == 1
                    ? sortBy(obj.optionsList, x => x.idValue)
                    : sortBy(obj.optionsList, x => x.value)
                }
                selectedIds={selectedIds[obj.FilterKeyName] || []}
                onChange={val =>
                  this.onMultiSelectDD(
                    val,
                    obj.optionsList,
                    obj.FilterKeyName,
                    obj.FilterDataType,
                    obj.optionsList.find(x => x.idValue != null).idValue,
                    (obj.optionsList[0].dependentFilter != null &&
                      obj.DependentFilter) ||
                      null
                  )}
              />
            )}
          </>
        );

      case "DateRange": {
        const rangeDateArray = colFilteredObj
          .find(x => x.keyName === obj.FilterKeyName)
          ?.value?.split("-");
        const rangeStart =
          rangeDateArray?.length >= 1 && rangeDateArray[0] !== "NONE"
            ? rangeDateArray[0]
            : moment().format(standardDateFormat);
        const rangeEnd =
          rangeDateArray?.length >= 2
            ? rangeDateArray[1]
            : moment().format(standardDateFormat);
        return (
          <SliderDatePicker
            key={obj.FilterKeyName + index}
            DatePickerOptional={obj.DatePickerOptional}
            clearFilterData={clearFilterData}
            isReporting
            isViewReport
            sliderType={3}
            radioSlider={reportRadioRangeQTRSlider}
            handelDateChangesSlideDate={(
              start,
              end,
              typeOfDate,
              QtrSelected
            ) => {
              this.handleNullableSliderDate(
                start,
                end,
                typeOfDate,
                QtrSelected,
                obj.FilterKeyName,
                obj.FilterDataType
              );
            }}
            title={obj.FilterName}
            selectedDate={moment(rangeEnd).format(standardDateFormat)}
            selectedStartDate={rangeStart}
            selectedEndDate={rangeEnd}
            onError={this.props.onError}
          />
        );
      }
      case "DateRangeWeeklySlider": {
        const rangeDateArray = colFilteredObj
          .find(x => x.keyName === obj.FilterKeyName)
          ?.value?.split("-");
        const rangeStart =
          rangeDateArray?.length >= 1 && rangeDateArray[0] !== "NONE"
            ? rangeDateArray[0]
            : moment().format(standardDateFormat);
        const rangeEnd =
          rangeDateArray?.length >= 2
            ? rangeDateArray[1]
            : moment().format(standardDateFormat);
        return (
          <SliderDatePicker
            key={obj.FilterKeyName + index}
            DatePickerOptional={obj.DatePickerOptional}
            clearFilterData={clearFilterData}
            isReporting
            isViewReport
            sliderType={4}
            radioSlider={reportRadioRangeWeeklySlider}
            handelDateChangesSlideDate={(
              start,
              end,
              typeOfDate,
              QtrSelected
            ) => {
              this.handleNullableSliderDate(
                start,
                end,
                typeOfDate,
                QtrSelected,
                obj.FilterKeyName,
                obj.FilterDataType
              );
            }}
            title={obj.FilterName}
            selectedDate={moment(rangeEnd).format(standardDateFormat)}
            selectedStartDate={rangeStart}
            selectedEndDate={rangeEnd}
            onError={this.props.onError}
          />
        );
      }
      case "NullableDateRange": {
        const dateArray = colFilteredObj
          .find(x => x.keyName === obj.FilterKeyName)
          ?.value?.split("-");

        const startDate =
          dateArray?.length >= 1 && dateArray[0] !== "NONE"
            ? dateArray[0]
            : moment().format(standardDateFormat);
        const endDate =
          dateArray?.length >= 2
            ? dateArray[1]
            : moment().format(standardDateFormat);
        return (
          <SliderDatePicker
            DatePickerOptional={obj.DatePickerOptional}
            clearFilterData={clearFilterData}
            handelDateChangesSlideDate={(
              start,
              end,
              typeOfDate,
              QtrSelected
            ) => {
              this.handleNullableSliderDate(
                start,
                end,
                typeOfDate,
                QtrSelected,
                obj.FilterKeyName,
                obj.FilterDataType
              );
            }}
            radioSlider={reportRadioSlider}
            selectedDate={moment(endDate).format(standardDateFormat)}
            selectedStartDate={startDate}
            selectedEndDate={endDate}
            isReporting
            isViewReport
            sliderType={1}
            title={obj.FilterName}
            onError={this.props.onError}
          />
        );
      }
      case "DateRangeSlider": {
        const rangeDateArray = colFilteredObj
          .find(x => x.keyName === obj.FilterKeyName)
          ?.value?.split("-");

        const rangeStartDate =
          rangeDateArray?.length >= 1 && rangeDateArray[0] !== "NONE"
            ? rangeDateArray[0]
            : moment().format(standardDateFormat);
        const rangeEndDate =
          rangeDateArray?.length >= 2
            ? rangeDateArray[1]
            : moment().format(standardDateFormat);
        return (
          <SliderDatePicker
            DatePickerOptional={obj.DatePickerOptional}
            clearFilterData={clearFilterData}
            handelDateChangesSlideDate={(
              start,
              end,
              typeOfDate,
              QtrSelected
            ) => {
              this.handleNullableSliderDate(
                start,
                end,
                typeOfDate,
                QtrSelected,
                obj.FilterKeyName,
                obj.FilterDataType
              );
            }}
            radioSlider={reportRadioRangeSlider}
            selectedDate={moment(rangeEndDate).format(standardDateFormat)}
            selectedStartDate={rangeStartDate}
            selectedEndDate={rangeEndDate}
            sliderType={2}
            isReporting
            isViewReport
            title={obj.FilterName}
            onError={this.props.onError}
          />
        );
      }
      case "Autocomplete": {
        let finalSelected = [];
        const selList =
          obj.optionsList.filter(
            opt =>
              (
                colFilteredObj.find(x => x.keyName === obj.FilterKeyName)
                  ?.value || []
              ).find(selectedValue => selectedValue === opt.id) !== undefined
          ) || [];
        finalSelected = selList.map(val => val.value) || [];
        if (selList.length == obj.optionsList.length && selList.length > 1 && reportSectionId!==7) {
          finalSelected.push("All");
        }
        return (
          <VirtualizedAutocomplete
            key={obj.FilterKeyName}
            parentKey={obj.FilterKeyName + index}
            allCleared={allCleared}
            dependentKey={dependentKey}
            reload={reload}
            clearFilterData={
              clearFilterData ||
              (
                obj.optionsList.filter(
                  opt =>
                    (
                      colFilteredObj.find(x => x.keyName === obj.FilterKeyName)
                        ?.value || []
                    ).find(selectedValue => selectedValue === opt.id) !==
                    undefined
                ) || []
              ).length === 0
            }
            isSelectAll={false}
            header={obj.FilterName}
            optionsList={
             removeDuplicates(obj.ShowLastValueInList == 1
                ? sortBy(obj.optionsList, x => x.idValue)
                : sortBy(obj.optionsList, x => x.value), "value")
            }
            selectedIds={finalSelected || []}
            onChange={val =>
              this.onMultiSelectDD(
                val,
                obj.optionsList,
                obj.FilterKeyName,
                obj.FilterDataType,
                obj.optionsList.find(x => x.idValue != null).idValue,
                (obj.optionsList[0].dependentFilter != null &&
                  obj.DependentFilter) ||
                  null,
                  reportSectionId !==7 ?1 :0
              )}
              reportSectionId={reportSectionId}
          />
        );
      }
    }
  };

  render() {
    const { filterConfig } = this.state;

    return (
      <>
        <React.StrictMode>
          {filterConfig?.length > 0 && (
            <div className={"row"} style={{ padding: "0px 1px 5px 10px" }}>
              {filterConfig
                .filter(
                  x =>
                    x.FilterDataType !== "NullableDateRange" &&
                    x.FilterDataType !== "DateRangeSlider" &&
                    x.FilterDataType !== "DateRange" &&
                    x.FilterDataType !== "DateRangeWeeklySlider"
                )
                .map((x, index) => (
                  <div
                    className={"col-xs-3"}
                    style={{ paddingRight: "5px", paddingTop: "5px" }}
                  >
                    {this.decideFilterComp(x, index)}
                    <span key={"span" + index}> &nbsp;</span>
                  </div>
                ))}

              {filterConfig
                .filter(
                  x =>
                    x.FilterDataType == "NullableDateRange" ||
                    x.FilterDataType == "DateRangeSlider" ||
                    x.FilterDataType == "DateRangeWeeklySlider" ||
                    x.FilterDataType == "DateRange"
                )
                .map((x, index) => (
                  <div
                    className={"col-xs-12  "}
                    style={{ marginTop: "10px", color: "#27608e" }}
                  >
                    <div className={"col-xs-6 no-padding align-date-range"}>
                      {this.decideFilterComp(x, index)}

                      <span key={"Span"+x.FilterKeyName + index}> &nbsp;</span>
                    </div>
                  </div>
                ))}
            </div>
          )}
        </React.StrictMode>
      </>
    );
  }
}
